import { defineComponent, ref, computed, resolveComponent, openBlock, createElementBlock, mergeProps, toHandlers, createVNode, normalizeProps, guardReactiveProps } from 'vue';
import { i as isVue3 } from '../OrAutocompleteV3-508d99c0.js';
import { OrIconV3 as script$1 } from '../or-icon-v3/index.js';
import '@vueuse/core';
import '@onereach/styles/screens.json';
import '@onereach/styles/tailwind.config.json';
import 'lodash/get';
import 'lodash/isElement';
import '../or-error-v3/index.js';
import '../or-hint-v3/index.js';
import '../or-icon-button-v3/index.js';
import '../or-tooltip-v3/index.js';
import '../or-popover-v3/index.js';
import '@floating-ui/dom';
import '../or-bottom-sheet-v3/index.js';
import '../or-overlay-v3/index.js';
import '../or-teleport-v3/index.js';
import '../or-input-box-v3/index.js';
import '../or-input-v3/index.js';
import '../OrInlineInputV3-46210775.js';
import '../or-inline-input-box-v3/index.js';
import '../or-text-v3/index.js';
import '../or-label-v3/index.js';
import '../or-loader-v3/index.js';
import '../or-menu-item-v3/index.js';
import '../or-tag-input-v3/index.js';
import '../or-tags-v3/index.js';
import '../or-button-v3/index.js';
import '../or-tag-v3/index.js';

var FabColor;
(function (FabColor) {
  FabColor["Primary"] = "primary";
  FabColor["Danger"] = "danger";
})(FabColor || (FabColor = {}));

const Fab = [
// Layout
'layout-inline-row justify-center',
// Box
'w-[56px]', 'h-[56px]',
// Shape
'rounded-full',
// Elevation
'enabled:shadow-button', 'dark:enabled:shadow-button-dark'];
const FabColors = {
  'primary': [
  // Theme
  'theme-preset-1-primary', 'dark:theme-preset-1-primary-dark'],
  'danger': [
  // Theme
  'theme-preset-1-error', 'dark:theme-preset-1-error-dark']
};

var script = defineComponent({
  name: 'OrFab',
  components: {
    OrIcon: script$1
  },
  props: {
    icon: {
      type: [String, Object],
      required: true
    },
    color: {
      type: String,
      default: () => FabColor.Primary
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click', 'focus', 'blur'],
  expose: ['root'],
  setup(props) {
    // Refs
    const root = ref();
    // Styles
    const rootStyles = computed(() => ['or-fab-v3', ...Fab, ...FabColors[props.color]]);
    return {
      root,
      rootStyles,
      isVue3
    };
  }
});

const _hoisted_1 = ["disabled"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrIcon = resolveComponent("OrIcon");
  return openBlock(), createElementBlock("button", mergeProps({
    ref: 'root',
    class: _ctx.rootStyles,
    type: 'button',
    disabled: _ctx.disabled
  }, toHandlers({
    ...(_ctx.isVue3 ? {} : _ctx.$listeners),
    click: e => _ctx.$emit('click', e),
    focus: e => _ctx.$emit('focus', e),
    blur: e => _ctx.$emit('blur', e)
  }, true)), [createVNode(_component_OrIcon, normalizeProps(guardReactiveProps(typeof _ctx.icon === 'string' ? {
    icon: _ctx.icon,
    size: 'l'
  } : {
    size: 'l',
    ..._ctx.icon
  })), null, 16 /* FULL_PROPS */)], 16 /* FULL_PROPS */, _hoisted_1);
}

script.render = render;
script.__file = "src/components/or-fab-v3/OrFab.vue";

export { FabColor, script as OrFabV3 };
